import { endAndReportPerformanceMeasure, reportError, reportInfo, startPerformanceMeasure } from '@ms/yammer-telemetry';
import { isAuthRedirect } from '@ms/yammer-web-authenticators';
import { checkThirdPartyCookieSupport, reportThirdPartyCookieEvent } from '@ms/yammer-web-support/dist/cookies';
import { isAuthCookieAvailable, writeHostingCookies } from '@ms/yammer-web-support/dist/hosting';
import { authReload, getUrlRootPath } from '@ms/yammer-web-support/dist/location';

import { setupAuthenticator } from '../../auth';
import config from '../../config';
import { setLocaleFromUserData } from '../1-main/bootstrapActions';
import { createYammerEmbedStore } from '../1-main/createStore';
import { isPermanentFailure } from '../1-main/isPermanentFailure';
import { loadLoginRenderer } from '../3-render';

import { configure as configureTelemetry } from './telemetry';

export const bootstrap = async (): Promise<void> => {
  const authenticator = await setupAuthenticator();

  await authenticator.initializeCurrentAccount();

  await configureTelemetry();

  if (isAuthRedirect()) {
    return;
  }
  let endedWithError = false;

  const measure = startPerformanceMeasure('auth_bootstrap');
  try {
    const yammerToken = await authenticator.acquireToken([config.msal.resources.yammer]);
    writeHostingCookies({
      yammerToken,
      shouldSetSameSite: true,
      partitioned: !checkThirdPartyCookieSupport(),
    });
    reportThirdPartyCookieEvent(yammerToken);
  } catch (err) {
    endedWithError = isPermanentFailure(err);
    reportError({
      error: err,
      eventProperties: { errorCode: 'AuthBootstrapFailed' },
    });

    const { store } = createYammerEmbedStore();
    setLocaleFromUserData(store.getState());
    const render = await loadLoginRenderer();
    const renderRoot = document.getElementById('root') as HTMLElement;
    render({ store, target: renderRoot, authenticator });

    throw err;
  } finally {
    reportInfo({
      eventName: 'auth_bootstrap_info',
      eventProperties: {
        isExecutingInIFrame: window.top !== window.self,
        urlRootPath: getUrlRootPath(window.location.pathname),
      },
    });
    endAndReportPerformanceMeasure({
      ...measure,
      eventProperties: {
        ...measure.eventProperties,
        endedWithError,
      },
    });
  }

  const authCookieAvailable = isAuthCookieAvailable();

  authReload(!authCookieAvailable);
};
